import { render, staticRenderFns } from "./LeaderEmail.vue?vue&type=template&id=c719adea&scoped=true"
import script from "./LeaderEmail.vue?vue&type=script&lang=js"
export * from "./LeaderEmail.vue?vue&type=script&lang=js"
import style0 from "./LeaderEmail.vue?vue&type=style&index=0&id=c719adea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c719adea",
  null
  
)

export default component.exports